<template>
  <div class="wrapper">
    <div class="left-col">
      <div class="left-colour"></div>
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(0, 5)"
        :key="item.id"
        class="left-col__item news"
        :class="'item-' + (index + 1)"
      >
        <div class="news__container">
          <div class="news__content">
            <div class="news__category">
              {{ item.sub_category.name }}
            </div>
            <div class="news__descr">
              <div class="news__img">
                <div class="category-img">
                  {{ item.sub_category.name }}
                </div>
                <ImageContainer
                  class="img"
                  :src="item.image.medium"
                  :thumb="item.image.thumbnail"
                  :alt="item.title"
                />
              </div>
              <div class="news__title">
                <h3 class="limited-text">{{ item.title }}</h3>
                <div class="data-news">
                  <span class="day">{{ handleDate(item.pub_date) }},</span>
                  <span class="time">{{ handleTime(item.pub_date) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div class="right-col">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(5, 7)"
        :key="item.id"
        :class="'item-' + (index + 1)"
      >
        <div class="news__container">
          <div class="news__content">
            <div class="news__category">
              {{ item.sub_category.name }}
            </div>
            <div class="news__descr">
              <div class="news__img">
                <ImageContainer
                  class="img"
                  :src="item.image.medium"
                  :thumb="item.image.thumbnail"
                  :alt="item.title"
                />
              </div>
              <div class="news__title">
                <h3 class="limited-text">{{ item.title }}</h3>
                <div class="data-news">
                  <span class="day">{{ handleDate(item.pub_date) }},</span>
                  <span class="time">{{ handleTime(item.pub_date) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";

export default {
  name: "FirstBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
$green: #447562;
$gray: rgba(255, 255, 255, 0.6);
$gray-category: #121212;
$color-left: #f4fffb;
$color-category: rgba(255, 255, 255, 0.7);

$width: 100%;
.flex {
  display: flex;
}
.left-colour {
  top: 0;
  left: -100%;
  position: absolute;
  height: 100%;
  width: 200%;
  background-color: $color-left;
  border-bottom-left-radius: 4px;
  pointer-events: none;
  z-index: 0;
  @media screen and (max-width: 992px) {
    display: none;
  }
}
.wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: $width;
  margin: 0 auto;
  transform: translateY(-4px);
  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: "left-col  left-col right-col";
    padding-top: 2rem;
  }
  @media screen and (max-width: 767px) {
    padding: 0;
    grid-template-columns: 1fr;
    grid-template-areas: "right-col" "left-col";
    max-width: 90%;
    transform: translateY(0px);
  }

  .left-col {
    position: relative;
    border-radius: 0px 0px 4px 0px;
    color: #121212;
    display: grid;
    gap: 10px;
    padding: 50px 0;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "item-1 item-2" "item-1 item-3" "item-1 item-4" "item-5 item-5";
    @media screen and (max-width: 992px) {
      gap: 30px;
      padding: 0 1rem;
      color: inherit;
      background: transparent;
      grid-area: left-col;
      grid-template-areas:
        "item-1 item-2"
        ". item-3"
        "item-4 item-5";
    }

    @media screen and (max-width: 767px) {
      grid-area: left-col;
      background: transparent;
      color: inherit;
      padding: 0 0.75rem;
      gap: 1rem;
      margin: 2rem 0;
      grid-template-areas:
        "item-1 item-2"
        "item-3 item-4" "item-5 item-5";
    }
    .item-1 {
      grid-area: item-1;
      width: 100%;
      padding: 0 1rem;
      transform: translateY(22px);
      @media screen and (max-width: 992px) {
        padding: 0;
        transform: translateY(70px);
      }
      @media screen and (max-width: 767px) {
        transform: translateY(0px);
      }
      .news {
        &__title {
          .data-news {
            color: $gray-category;
            @media screen and (max-width: 992px) {
              color: #fff;
            }
          }
          @media screen and (max-width: 992px) {
            padding: 0;
            font-size: 0.9585em;

            // font-family: Roboto;
          }
          @media screen and (max-width: 767px) {
            font-size: 0.875rem;
            font-family: "Roboto";
            line-height: 1.5;
            margin-top: 5px;
          }
        }
        &__img {
          .img {
            padding-bottom: 85%;
          }
          @media screen and (max-width: 992px) {
            max-width: 100%;
            height: 125px;
            .img {
              padding-bottom: 0;
            }
          }
          @media screen and (max-width: 767px) {
            max-width: 100%;
            // min-height: 128px;
            // height: 128px;
            height: auto;
            .img {
              padding-bottom: 66%;
            }
          }
        }
        &__content {
          position: relative;
          font-family: "Roboto";
          font-size: 1.2em;
          @media screen and (max-width: 992px) {
            // font-family: Open Sans;
            // font-weight: 600;
            font-size: 1.2em;
            line-height: 22px;
          }
          @media screen and (max-width: 767px) {
            font-weight: 600;
            height: 100%;
          }
        }

        &__category {
          position: absolute;
          z-index: 1;
          background: $color-left;
          color: $gray-category;
          padding: 0 0.2em;
          @media screen and (max-width: 992px) {
            position: absolute;
            z-index: 1;
            background: $green;
            color: $color-category;
            font-family: "Open Sans";
            font-weight: 600;
            font-size: 13px;
            text-transform: uppercase;
          }
          @media screen and (max-width: 767px) {
            background: $green;
            color: $color-category;
            font-size: 10px;
            text-transform: uppercase;
          }
        }
      }
    }
    .item-2 {
      grid-area: item-2;
      width: 100%;
      .news {
        &__category {
          font-size: 0.9rem;
          color: $gray-category;
          @media screen and (max-width: 992px) {
            position: absolute;
            z-index: 1;
            background: $green;
            color: $color-category;
            font-family: "Open Sans";
            font-weight: 600;
            font-size: 13px;
            text-transform: uppercase;
          }

          @media screen and (max-width: 767px) {
            position: absolute;
            z-index: 1;
            background-color: $green;
            font-size: 10px;
          }
        }
        &__content {
          position: relative;
          @media screen and (max-width: 992px) {
            // font-family: Open Sans;
            // font-weight: 600;
            // font-size: 1.4em;
            line-height: 22px;
          }
        }
        &__img {
          flex: 0 0 25%;
          height: 5vw;
          @media screen and (max-width: 992px) {
            max-width: 100%;
            height: 125px;
          }
          @media screen and (max-width: 767px) {
            // min-height: 128px;
            max-width: 100%;
            min-width: none;
            height: auto;
            .img {
              padding-bottom: 66%;
            }
          }
        }
        &__descr {
          display: flex;
          @media screen and (max-width: 992px) {
            flex-direction: column;
          }
        }
        &__title {
          font-size: 1em;
          padding: 0 1.2rem 0 0.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .data-news {
            color: $gray-category;
            @media screen and (max-width: 992px) {
              color: #fff;
            }
          }
          @media screen and (max-width: 992px) {
            padding: 0;
            font-size: 1.15em;
            // font-family: Open Sans;
          }
          @media screen and (max-width: 767px) {
            font-size: 0.875rem;
            font-family: "Roboto";
            line-height: 1.5;
            margin-top: 5px;
          }
        }
      }
    }
    .item-3 {
      grid-area: item-3;
      width: 100%;

      z-index: 0;
      .news {
        &__category {
          font-size: 0.9rem;
          color: $gray-category;
          @media screen and (max-width: 992px) {
            position: absolute;
            z-index: 1;
            background: $green;
            color: $color-category;
            font-family: "Open Sans";
            font-weight: 600;
            font-size: 13px;
            text-transform: uppercase;
          }
        }
        &__content {
          @media screen and (max-width: 992px) {
            // font-family: Open Sans;
            // font-weight: 600;
            // font-size: 1.2rem;
            line-height: 22px;
          }
        }
        &__img {
          flex: 0 0 25%;
          height: 5vw;
          @media screen and (max-width: 992px) {
            max-width: 100%;
            height: 125px;
          }
          @media screen and (max-width: 767px) {
            height: auto;
            .img {
              padding-bottom: 66%;
            }
          }
        }
        &__descr {
          display: flex;
          @media screen and (max-width: 992px) {
            flex-direction: column;
          }
        }
        &__title {
          padding: 0 1.2rem 0 0.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .data-news {
            color: $gray-category;
            @media screen and (max-width: 992px) {
              color: #fff;
            }
          }
          @media screen and (max-width: 992px) {
            padding: 0;
            font-size: 1.15em;
          }
          @media screen and (max-width: 767px) {
            font-size: 0.875rem;
            font-family: "Roboto";
            line-height: 1.5;
            margin-top: 5px;
          }
        }
      }
    }
    .item-4 {
      grid-area: item-4;
      width: 100%;
      @media screen and (max-width: 992px) {
        padding: 0;
        transform: translateY(-120px);
      }
      @media screen and (max-width: 767px) {
        transform: translateY(0px);
      }
      .news {
        &__category {
          font-size: 0.9rem;
          color: $gray-category;
          @media screen and (max-width: 992px) {
            position: absolute;
            z-index: 1;
            background: $green;
            color: $color-category;
            font-family: "Open Sans";
            font-weight: 600;
            font-size: 13px;
            text-transform: uppercase;
          }
        }
        &__content {
          position: relative;
          @media screen and (max-width: 992px) {
            // font-family: Open Sans;
            // font-weight: 600;
            // font-size: 1.2rem;
            line-height: 22px;
          }
        }
        &__img {
          flex: 0 0 25%;
          height: 5vw;
          @media screen and (max-width: 992px) {
            max-width: 100%;
            height: 125px;
          }
          @media screen and (max-width: 767px) {
            height: auto;
            .img {
              padding-bottom: 66%;
            }
          }
        }
        &__descr {
          display: flex;
          @media screen and (max-width: 992px) {
            flex-direction: column;
          }
        }
        &__title {
          padding: 0 1.2rem 0 0.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          font-size: 1em;
          .data-news {
            color: $gray-category;
            @media screen and (max-width: 992px) {
              color: #fff;
            }
          }
          @media screen and (max-width: 992px) {
            font-size: 1.15em;
          }
          @media screen and (max-width: 767px) {
            font-size: 0.875rem;
            font-family: "Roboto";
            line-height: 1.5;
            margin-top: 5px;
          }
        }
      }
    }
    .item-5 {
      grid-area: item-5;
      width: 90%;
      margin: 0 auto;
      margin-top: 3rem;
      @media screen and (max-width: 992px) {
        margin-top: 0;
        width: 100%;
      }
      .news {
        &__title {
          padding: 0 1rem;
          .data-news {
            color: $gray-category;
            @media screen and (max-width: 992px) {
              color: #fff;
            }
          }
          @media screen and (max-width: 992px) {
            padding: 0;
            // font-family: Open Sans;
            // font-weight: 600;
            font-size: 0.9584em;
            line-height: 22px;
          }
          @media screen and (max-width: 767px) {
            font-size: 0.875rem;
            font-family: "Roboto";
            line-height: 1.5;
            margin: 0;
            padding: 0 0.5rem;
            min-height: 104px;
            display: flex;
            flex-direction: column;

            justify-content: center;
            width: 100%;
          }
        }
        &__content {
          position: relative;
          @media screen and (max-width: 992px) {
            // font-family: Open Sans;
            // font-weight: 600;
            // font-size: 1.2rem;
            line-height: 22px;
          }
        }

        &__img {
          width: 100%;
          flex: 0 0 50%;
          // max-width: 365px;
          // height: 274px;
          position: relative;
          .category-img {
            display: block;
          }
          .img {
            padding-bottom: 80%;
          }
          @media screen and (max-width: 992px) {
            max-width: 100%;
            height: 125px;
            flex: none;
            .category-img {
              display: none;
            }
            .img {
              padding-bottom: 0%;
            }
          }
          @media screen and (max-width: 767px) {
            max-width: 140px;
            height: 104px;
          }
        }
        &__descr {
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Roboto;
          font-size: 1.2em;
          font-weight: 500;
          @media screen and (max-width: 992px) {
            flex-direction: column;
          }
          @media screen and (max-width: 767px) {
            flex-direction: row;
            align-items: flex-start;
          }
        }
        &__category {
          display: none;
          position: absolute;
          z-index: 1;
          background: $color-category;
          color: $gray-category;
          padding: 2px 5px;

          @media screen and (max-width: 992px) {
            display: block;
            position: absolute;
            z-index: 1;
            background: $green;
            color: $color-category;
            font-family: "Open Sans";
            font-weight: 600;
            font-size: 13px;
            text-transform: uppercase;
          }
        }
      }
    }
  }
  .right-col {
    display: flex;
    justify-content: space-between;
    padding: 6rem 2rem 0;

    @media screen and (max-width: 992px) {
      grid-area: right-col;
      flex-direction: column;
      padding: 0 1rem;
      justify-content: space-around;
    }
    @media screen and (max-width: 767px) {
      margin-top: 2.5rem;
    }
    .item-1 {
      flex: 0 0 47%;
      padding: 0 0.5rem;
      @media screen and (max-width: 992px) {
        padding: 0;
        transform: translateY(70px);
      }
      @media screen and (max-width: 767px) {
        margin-top: 2em;
        margin-bottom: 1rem;
        transform: translateY(0px);
      }
      .news {
        &__container {
          @media screen and (max-width: 767px) {
          }
        }
        &__img {
          text-align: left;
          .img {
            padding-bottom: 75%;
          }
          @media screen and (max-width: 992px) {
            max-width: 100%;
            height: 125px;
            .img {
              padding-bottom: 0;
            }
          }
          @media screen and (max-width: 767px) {
            max-width: 100%;
            height: 250px;
            // height: 100%;
            // .img {
            //   padding-bottom: 50%;
            // }
          }
        }
        &__content {
          position: relative;
          font-family: "Roboto";
          font-size: 1.2em;
          text-align: center;
          @media screen and (max-width: 992px) {
            text-align: left;
            // font-family: Open Sans;
            // font-weight: 600;
            // font-size: 1.2rem;
            line-height: 22px;
          }
          @media screen and (max-width: 767px) {
            height: auto;
          }
        }
        &__descr {
          @media screen and (max-width: 767px) {
            height: 100%;
          }
        }
        &__category {
          position: absolute;
          z-index: 1;
          background: $green;
          color: $color-category;
          padding: 2px 5px;
          font-weight: 600;

          @media screen and (max-width: 767px) {
            font-family: "Open Sans";
            font-weight: 600;
            font-size: 12px;
            line-height: 14px;
          }
        }
        &__title {
          @media screen and (max-width: 992px) {
            font-size: 1.15rem;
          }
          @media screen and (max-width: 767px) {
            font-size: 0.875rem;
            font-weight: 600;
            line-height: 1.5;
            font-family: "Roboto";
            text-align: center;
          }
          .data-news {
            color: #fff;

            @media screen and (max-width: 767px) {
              color: rgba(255, 255, 255, 0.6);
            }
          }
        }
      }
    }
    .item-2 {
      flex: 0 0 47%;
      padding: 0 0.5rem;
      @media screen and (max-width: 992px) {
        padding: 0;
      }
      .news {
        &__container {
          @media screen and (max-width: 992px) {
            transform: translateY(15px);
          }
          @media screen and (max-width: 767px) {
            transform: translateY(0px);
          }
        }
        &__img {
          text-align: left;
          .img {
            padding-bottom: 75%;
          }
          @media screen and (max-width: 992px) {
            max-width: 100%;
            height: 125px;
            .img {
              padding-bottom: 0;
            }
          }
          @media screen and (max-width: 767px) {
            min-width: 140px;
            height: 104px;
          }
        }
        &__content {
          position: relative;
          font-family: "Roboto";
          font-size: 1.2em;
          text-align: center;
          position: relative;
          @media screen and (max-width: 992px) {
            // font-family: Open Sans;
            // font-weight: 600;
            // font-size: 1.2rem;
            line-height: 22px;
            text-align: left;
          }
        }
        &__category {
          position: absolute;
          z-index: 1;
          background: $green;
          color: $color-category;
          padding: 2px 5px;
          font-weight: 600;

          @media screen and (max-width: 767px) {
            font-family: "Open Sans";
            font-weight: 600;
            font-size: 10px;
            line-height: 14px;
          }
        }
        &__descr {
          @media screen and (max-width: 767px) {
            display: flex;
          }
        }
        &__title {
          @media screen and (max-width: 992px) {
            font-size: 1.15rem;
          }
          @media screen and (max-width: 767px) {
            text-align: left;
            margin-left: 0.5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 0.875rem;
            font-weight: 600;
            line-height: 1.5;
            font-family: "Roboto";
            text-align: left;
          }

          .data-news {
            color: #fff;
            @media screen and (max-width: 767px) {
              color: $gray;
            }
          }
        }
      }
    }
  }
}
.data-news {
  margin-top: 8px;
  font-size: 0.88em;

  font-family: Open Sans;
  color: $gray;
  @media screen and (max-width: 992px) {
    font-size: 13px;
    color: #fff;
    font-weight: normal;
  }
  @media screen and (max-width: 767px) {
    color: $gray;
    font-family: Open Sans;
    font-size: 10px;
    line-height: 14px;
  }
}
.category-img {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  font-family: Open Sans;
  font-size: 0.8334em;
  line-height: 22px;
  background-color: $color-left;
  color: $gray-category;
  padding: 0 5px;
}
.news {
  &__title {
    font-size: 1em;
    font-weight: 500;
    @media screen and (max-width: 992px) {
      font-size: 1em;
    }
  }
  &__category {
    font-family: Open Sans;
    font-size: 16px;
    line-height: 22px;
    @media screen and (max-width: 992px) {
      padding: 2px 5px;
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      color: $color-category;
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-size: 10px !important;
    }
  }
  .data-news {
    @media screen and (max-width: 767px) {
      color: var(--color-category) !important;
    }
  }
}
</style>
